var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityAppjourney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.743,
    height: 41.742,
    viewBox: "0 0 41.743 41.742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path8333",
    d: "M7.778.926h23.48a1.952,1.952,0,0,1,1.957,1.957V22.123a1.952,1.952,0,0,1-1.957,1.957H7.778a1.952,1.952,0,0,1-1.957-1.957V2.883A1.952,1.952,0,0,1,7.778.926Z",
    transform: "translate(8.528 1.357)",
    fill: "#e4eff8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path8336",
    d: "M5.821,5.218V1.957A1.952,1.952,0,0,1,7.778,0h23.48a1.952,1.952,0,0,1,1.957,1.957V5.218Z",
    transform: "translate(8.528 0)",
    fill: "#ffca28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path8340",
    d: "M3.015,6.35A1.952,1.952,0,0,0,1.058,8.307V27.221H34.974V8.307A1.952,1.952,0,0,0,33.018,6.35Z",
    transform: "translate(1.551 9.303)",
    fill: "#e4eff8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path8505",
    d: "M3.175,6.35v13.7A1.952,1.952,0,0,0,5.132,22H31.221a1.945,1.945,0,0,0,.652-.119V8.307A1.952,1.952,0,0,0,29.917,6.35Z",
    transform: "translate(4.652 9.303)",
    fill: "#c4dcf0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path8342",
    d: "M34.975,9.726c-4.3,8.458-27.111,10.186-33.916,10.516v2.034H34.975Z",
    transform: "translate(1.551 14.249)",
    fill: "#c4dcf0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path8344",
    d: "M4.073,7.408A1.952,1.952,0,0,0,2.117,9.365V28.279h28.7V9.365a1.952,1.952,0,0,0-1.957-1.957Z",
    transform: "translate(3.101 10.854)",
    fill: "#549ad4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path8510",
    d: "M3.175,7.408V18.5a1.952,1.952,0,0,0,1.957,1.957H29.264V9.365a1.952,1.952,0,0,0-1.957-1.957Z",
    transform: "translate(4.652 10.854)",
    fill: "#3588cb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path8348",
    d: "M30.815,10.954c-6.582,5.165-21.246,6.81-28.7,7.327v4.8h28.7Z",
    transform: "translate(3.101 16.049)",
    fill: "#3588cb"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path8350",
    d: "M5.4,2.381H31.486a1.952,1.952,0,0,1,1.957,1.957V25.861a1.952,1.952,0,0,1-1.957,1.957H5.4A1.952,1.952,0,0,1,3.44,25.861V4.338A1.952,1.952,0,0,1,5.4,2.381Z",
    transform: "translate(5.039 3.489)",
    fill: "#e4eff8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "path8354",
    d: "M32.2,2.438c-.122,20-22.086,22.855-28.763,23.263v.078A1.952,1.952,0,0,0,5.4,27.735H31.486a1.952,1.952,0,0,0,1.957-1.957V4.255A1.949,1.949,0,0,0,32.2,2.438Z",
    transform: "translate(5.039 3.571)",
    fill: "#c4dcf0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "path8356",
    d: "M3.44,7.6V4.338A1.952,1.952,0,0,1,5.4,2.381H31.486a1.952,1.952,0,0,1,1.957,1.957V7.6Z",
    transform: "translate(5.039 3.489)",
    fill: "#427096"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path8358",
    d: "M39.134,14.817v1.3a3.913,3.913,0,0,1-3.913,3.913H3.913A3.913,3.913,0,0,1,0,16.121v-1.3Z",
    transform: "translate(0 21.708)",
    fill: "#e4eff8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path8362",
    d: "M17.143,14.817v1.3a3.913,3.913,0,0,1-3.913,3.913h2.609a3.913,3.913,0,0,0,3.913-3.913v-1.3Z",
    transform: "translate(19.383 21.708)",
    fill: "#c4dcf0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path8364",
    d: "M14.829,14.817v1.3a1.3,1.3,0,0,1-1.3,1.3H7.654a1.3,1.3,0,0,1-1.3-1.3v-1.3Z",
    transform: "translate(9.304 21.708)",
    fill: "#427096"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45603",
    "data-name": "Group 45603",
    transform: "translate(10.436 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "circle8387",
    d: "M5.538,3.827a.652.652,0,1,1-.652-.652.652.652,0,0,1,.652.652Z",
    transform: "translate(-4.233 4.652)",
    fill: "#e4eff8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle8389",
    d: "M6.6,3.827a.652.652,0,1,1-.652-.652A.652.652,0,0,1,6.6,3.827Z",
    transform: "translate(-2.683 4.652)",
    fill: "#e4eff8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle8391",
    d: "M7.654,3.827A.652.652,0,1,1,7,3.175.652.652,0,0,1,7.654,3.827Z",
    transform: "translate(-1.132 4.652)",
    fill: "#e4eff8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8393",
    d: "M7.408,2.381V7.6h1.3V2.381Z",
    transform: "translate(0.418 3.488)",
    fill: "#e4eff8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle8397",
    d: "M7.919,1.446A.652.652,0,1,1,7.267.794a.652.652,0,0,1,.652.652Z",
    transform: "translate(-0.744 1.163)",
    fill: "#e4eff8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle8399",
    d: "M8.977,1.446A.652.652,0,1,1,8.325.794.652.652,0,0,1,8.977,1.446Z",
    transform: "translate(0.806 1.163)",
    fill: "#e4eff8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "circle8401",
    d: "M10.036,1.446A.652.652,0,1,1,9.383.794.652.652,0,0,1,10.036,1.446Z",
    transform: "translate(2.357 1.163)",
    fill: "#e4eff8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8403",
    d: "M9.789,0V5.219h1.3V0Z",
    transform: "translate(3.907 0)",
    fill: "#e4eff8"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path8405",
    d: "M9.384,6.879a.652.652,0,1,0,0,1.3H21.777a.652.652,0,1,0,0-1.3Z",
    transform: "translate(12.793 10.078)",
    fill: "#427096"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path8408",
    d: "M9.388,5.82a.652.652,0,1,0,0,1.3h9.119a.652.652,0,1,0,0-1.3Z",
    transform: "translate(12.798 8.527)",
    fill: "#427096"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path8499",
    d: "M10.9,12.921a1.3,1.3,0,0,1-1.3,1.3H6.332a1.3,1.3,0,0,1-1.3-1.3V10.312c0-.723.6-1.456,1.3-1.3H10.9Z",
    transform: "translate(7.365 13.168)",
    fill: "#ffca28"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "path8410",
    d: "M8.811,9.258a.652.652,0,0,0-.448.2L6.871,10.948l-.193-.188a.654.654,0,1,0-.924.924l.655.65a.652.652,0,0,0,.924,0L9.288,10.38a.652.652,0,0,0-.477-1.122Z",
    transform: "translate(8.132 13.563)",
    fill: "#427096"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "path8417",
    d: "M10.9,9.481a1.3,1.3,0,0,1-1.3,1.3H6.332a1.3,1.3,0,0,1-1.3-1.3V6.873c0-.723.6-1.456,1.3-1.3H10.9Z",
    transform: "translate(7.365 8.129)",
    fill: "#ffca28"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path8414",
    d: "M8.82,5.819a.652.652,0,0,0-.448.2L6.879,7.509l-.193-.188a.652.652,0,1,0-.924.92l.655.655a.652.652,0,0,0,.924,0L9.3,6.94A.652.652,0,0,0,8.82,5.819Z",
    transform: "translate(8.123 8.524)",
    fill: "#427096"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "path8490",
    d: "M9.384,10.584a.652.652,0,1,0,0,1.3H21.777a.652.652,0,1,0,0-1.3Z",
    transform: "translate(12.793 15.506)",
    fill: "#365b7a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "path8492",
    d: "M9.388,9.525a.652.652,0,1,0,0,1.3h9.119a.652.652,0,1,0,0-1.3Z",
    transform: "translate(12.798 13.955)",
    fill: "#427096"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "path8494",
    d: "M12.621,9.525c-.715.472-1.45.905-2.2,1.3h5.612a.652.652,0,1,0,0-1.3Z",
    transform: "translate(15.271 13.955)",
    fill: "#365b7a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "path8515",
    d: "M10.756,9c-.427,4.146-4.846,4.523-5.657,4.558a1.3,1.3,0,0,0,1.129.66H9.488a1.3,1.3,0,0,0,1.3-1.3V9Z",
    transform: "translate(7.47 13.18)",
    fill: "#ecb200"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "path8520",
    d: "M23.008,2.387c-1.839,3.04-7.958,4.5-13.677,5.2H24.81V4.329a1.946,1.946,0,0,0-1.8-1.941Z",
    transform: "translate(13.672 3.498)",
    fill: "#365b7a"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "path8525",
    d: "M24.331.006c-1.839,3.04-7.958,4.5-13.677,5.2H26.133V1.948a1.946,1.946,0,0,0-1.8-1.941Z",
    transform: "translate(15.61 0.009)",
    fill: "#ecb200"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "path8527",
    d: "M10.756,5.556C10.329,9.7,5.91,10.08,5.1,10.114a1.3,1.3,0,0,0,1.129.66H9.488a1.3,1.3,0,0,0,1.3-1.3V5.556Z",
    transform: "translate(7.47 8.14)",
    fill: "#ecb200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityAppjourney);
export default __webpack_public_path__ + "static/media/university-appjourney.d34f6636e871e359842e22d8625bf480.svg";
export { ForwardRef as ReactComponent };